export default __webpack_public_path__ + "static/Perroquet-site-web-membre-medinsoft-8b310ca1a979c569005c0a941d752dda.jpg";